// extracted by mini-css-extract-plugin
export default {"scroll":"burger-ingredients_scroll__ycqk1","global":"burger-ingredients_global__vf7D+","modal":"burger-ingredients_modal__EZP8D"};